import UnderlineShape from "@/components/shape/underline";
import ResetPasswordForm from "./forget-password-form";

import AuthWrapperOne from "@/app/shared/auth-layout/auth-wrapper-one";
import AuthWrapperFour from "@/app/shared/auth-layout/auth-wrapper-four";
import ForgetPasswordForm from "./forget-password-form";

export default function ForgetPasswordPage() {
  return (
    <AuthWrapperFour
      title={
        <>
          Reset your{" "}
          <span className="relative inline-block">
            password!
            <UnderlineShape className="absolute -bottom-2 end-0 h-2.5 w-28 text-blue xl:-bottom-1.5 xl:w-36" />
          </span>
        </>
      }

    >
      <ForgetPasswordForm />
    </AuthWrapperFour>
  );
}
